import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsPaymentOptions({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M1 12.72c0 .65.52 1.17 1.17 1.17h11.66c.65 0 1.17-.52 1.17-1.17V8H1v4.72zm4.67-1.65c0-.16.13-.3.29-.3h3.3c.16 0 .3.14.3.3v.97a.3.3 0 01-.3.3h-3.3a.3.3 0 01-.3-.3v-.97zm-3.11 0c0-.16.13-.3.29-.3H4.6c.16 0 .29.14.29.3v.97a.3.3 0 01-.3.3H2.86a.3.3 0 01-.3-.3v-.97zM15 4.17v1.48H1V4.17C1 3.52 1.52 3 2.17 3h11.66c.65 0 1.17.52 1.17 1.17z" />
    </svg>
  );
}

SvgSettingsPaymentOptions.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsPaymentOptions.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsPaymentOptions svgRef={ref} {...props} />
));
export default ForwardRef;
